var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_2835_759)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2835_759",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2835_759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98108 23.5312H15.6061V22.8767C15.6061 22.2027 15.0597 21.6563 14.3856 21.6563H8.20152C7.5275 21.6563 6.98108 22.2027 6.98108 22.8767V23.5312Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79346 21.6562H12.7935V19.125H9.79346V21.6562Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.114 9.98438V17.7172C22.114 18.4947 21.4837 19.125 20.7061 19.125H1.87655C1.09903 19.125 0.46875 18.4947 0.46875 17.7172V4.78284C0.46875 4.00528 1.09903 3.375 1.87655 3.375H13.4062",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3643 16.1777H0.46875",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 13.9219H4.51566",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6402 10.7826L13.2174 9.35981L13.9895 8.58769C13.9895 8.58764 13.9895 8.58759 13.9895 8.5875C13.7028 8.13834 13.4914 7.6365 13.3725 7.09987H12.2813L12.2812 7.09983V5.08767H12.2813H13.3713C13.4896 4.55025 13.7007 4.04766 13.9873 3.59775C13.9873 3.5977 13.9873 3.59766 13.9873 3.59756L13.2174 2.82769L14.6402 1.40489L15.4088 2.17341C15.4088 2.17345 15.4088 2.17345 15.4089 2.17341C15.859 1.88555 16.3621 1.67339 16.9002 1.55428V0.46875L18.9123 0.468796V1.55302C19.4512 1.67161 19.955 1.88344 20.4058 2.1712C20.4059 2.17125 20.406 2.1712 20.406 2.17116L21.1723 1.40489L22.5951 2.82773L21.8288 3.594C21.8288 3.59405 21.8288 3.59414 21.8288 3.59419C22.1166 4.04498 22.3284 4.54884 22.447 5.08767H23.5312H23.5312V7.09983L23.5312 7.09987H22.4457C22.3266 7.63791 22.1145 8.14102 21.8266 8.59111C21.8265 8.59116 21.8265 8.5912 21.8266 8.59125L22.5951 9.35981L21.1723 10.7826M14.6402 10.7826C14.6402 10.7827 14.6402 10.7827 14.6402 10.7826ZM14.6402 10.7826L15.4123 10.0105C15.4124 10.0105 15.4125 10.0105 15.4125 10.0105C15.8617 10.2972 16.3635 10.5086 16.9002 10.6275V11.7188H18.9123V10.6287C19.4497 10.5104 19.9523 10.2993 20.4023 10.0127C20.4023 10.0127 20.4024 10.0127 20.4024 10.0128L21.1723 10.7826M21.1723 10.7826C21.1723 10.7827 21.1723 10.7827 21.1723 10.7826Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3437 6.09375C20.3437 4.74755 19.2525 3.65625 17.9062 3.65625C16.56 3.65625 15.4688 4.74755 15.4688 6.09375C15.4688 7.43995 16.56 8.53125 17.9062 8.53125C19.2525 8.53125 20.3437 7.43995 20.3437 6.09375Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2045 9.24531C10.2045 9.06789 10.1861 8.89473 10.1514 8.72763L10.8777 8.30828L10.0863 6.93742L9.35946 7.35709C9.10249 7.12727 8.79836 6.94914 8.4633 6.83898V6.00039H6.88043V6.83898C6.54536 6.94914 6.24119 7.12727 5.98422 7.35709L5.25738 6.93742L4.46594 8.30828L5.19227 8.72763C5.15754 8.89473 5.13921 9.06789 5.13921 9.24531C5.13921 9.42273 5.15754 9.59589 5.19227 9.763L4.46594 10.1823L5.25738 11.5532L5.98422 11.1335C6.24119 11.3634 6.54536 11.5415 6.88043 11.6516V12.4902H8.4633V11.6516C8.79836 11.5415 9.10249 11.3634 9.35946 11.1335L10.0863 11.5532L10.8777 10.1823L10.1514 9.763C10.1861 9.59589 10.2045 9.42273 10.2045 9.24531Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2835_759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.afafd431c23542374d312cbb3322ce86.svg";
export { ForwardRef as ReactComponent };